import { render, staticRenderFns } from "./NoHeaderFooterLayout.vue?vue&type=template&id=07f76e23&scoped=true&"
import script from "./NoHeaderFooterLayout.vue?vue&type=script&lang=js&"
export * from "./NoHeaderFooterLayout.vue?vue&type=script&lang=js&"
import style0 from "./NoHeaderFooterLayout.vue?vue&type=style&index=0&id=07f76e23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f76e23",
  null
  
)

export default component.exports